/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Unlock_TitleInputs */



/**
* | output |
* | --- |
* | "Unlock Record" |
*
* @param {Explorer_Info_Unlock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unlock_title = /** @type {((inputs?: Explorer_Info_Unlock_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unlock_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deverrouiller l'enregistrement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entsperrdatensatz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sblocca record")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разблокировать запись")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desbloquear registro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("解锁记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レコードのロックを解除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड अनलॉक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desbloquear registro")
	return /** @type {LocalizedString} */ ("Unlock Record")
});